export const count_how_much_the_amount_has_changed = (new_price, old_price) => {
  const total = ((old_price - new_price) / old_price) * 100;
  return total;
};
